import { Component, OnInit,Inject, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-deleteride',
  templateUrl: './deleteride.component.html',
  styleUrls: ['./deleteride.component.scss']
})
export class DeleterideComponent implements OnInit {
  isDeleted2 = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,public service:CommonService,private snack:MatSnackBar ,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<DeleterideComponent>) { }

  ngOnInit(): void {}
  rideDelete(){
    this.service.dltride(this.data)
    .subscribe((res:any)=>{
      if(res.message == "Success"){
        this.snack.open("Deleted successfully",'',{
          duration:1000,
         verticalPosition:'top',
         horizontalPosition: 'end',

        })
        this.isDeleted2.emit(true)
        this.dialogRef.close();
        
      }else{
        alert("something went wrong");
      }
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
